import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { DateienObjectType } from '../Enums/DateienObjectType.enum';
import { EMode } from '../Enums/EMode.enum';
import { Entities } from '../Enums/Entities.enum';

import { FileEntity } from './FileEntity.entity';

export class File<T extends EMode = EMode.entity> {
  /** Alias: code */
  id?: number;
  /** Alias: dateienType */
  fileType?: DateienObjectType;
  /** Alias: objMemberCode */
  objMemberCode?: number;
  /** Alias: name */
  name?: string;
  /** Alias: info1 */
  info1?: string;
  /** Alias: info2 */
  info2?: string;
  /** Alias: stillgelegt */
  deactivated?: boolean;
  /** Alias: pfad */
  path?: string;
  /** Alias: localFilename */
  localFilename?: string;
  /** Alias: dMSId */
  dMSId?: string;
  /** Alias: anhangAngebot */
  asAttachmentOffer?: boolean;
  /** Alias: anhangAuftrag */
  asAttachmentOrderConfirmation?: boolean;
  /** Alias: anhangBedarf */
  asAttachmentDemand?: boolean;
  /** Alias: anhangBestellung */
  asAttachmentOrder?: boolean;
  /** Alias: anhangKalkulation */
  asAttachmentCalculation?: boolean;
  /** Alias: anhangLieferschein */
  asAttachmentDeliveryNote?: boolean;
  /** Alias: anhangRechnung */
  asAttachmentInvoice?: boolean;
  /** Alias: showInShop */
  showInShop?: boolean;
  /** Alias: index */
  index?: number;
  /** Alias: fileInfos */
  fileInfos?: FileEntity<T>;
  /** Alias: parentCode */
  parentId?: number;
  /** Alias: updateTime */
  updateTime?: string;
  /** Alias: insertTime */
  insertTime?: string;

  __typename?: string;
}

const fields: FieldDefinitions<File> = {
  id: {
    alias: 'code',
  },
  fileType: {
    alias: 'dateienType',
  },
  objMemberCode: {
    alias: 'objMemberCode',
  },
  name: {
    alias: 'name',
  },
  info1: {
    alias: 'info1',
  },
  info2: {
    alias: 'info2',
  },
  deactivated: {
    alias: 'stillgelegt',
  },
  path: {
    alias: 'pfad',
  },
  localFilename: {
    alias: 'localFilename',
  },
  dMSId: {
    alias: 'dMSId',
  },
  asAttachmentOffer: {
    alias: 'anhangAngebot',
  },
  asAttachmentOrderConfirmation: {
    alias: 'anhangAuftrag',
  },
  asAttachmentDemand: {
    alias: 'anhangBedarf',
  },
  asAttachmentOrder: {
    alias: 'anhangBestellung',
  },
  asAttachmentCalculation: {
    alias: 'anhangKalkulation',
  },
  asAttachmentDeliveryNote: {
    alias: 'anhangLieferschein',
  },
  asAttachmentInvoice: {
    alias: 'anhangRechnung',
  },
  showInShop: {
    alias: 'showInShop',
  },
  index: {
    alias: 'index',
  },
  fileInfos: {
    alias: 'fileInfos',
    entity: Entities.fileEntity,
  },
  parentId: {
    alias: 'parentCode',
  },
  updateTime: {
    alias: 'updateTime',
  },
  insertTime: {
    alias: 'insertTime',
  },
  __typename: {
    alias: '__typename',
  },
};

export const fileEntityDefinition: EntitiyDefinition<File> = {
  local: {},
  remote: {
    queryName: '',
    fragmentName: 'Datei',
    withPaginationWrapper: false,
  },
  fieldDefinitions: fields,
};
